const meta = document.getElementById('post-metabox-main');
const metaMobile = document.getElementById('post-metabox-mobile');
if (meta && metaMobile) {
	let html = meta.innerHTML;
	metaMobile.innerHTML = html;
}
